import { replaceAll } from '../string.esm.js';
import createCache from '@emotion/cache';

var disablePrefix = ['letter-spacing'];
var cache = /*#__PURE__*/createCache({
  key: 'sajari',
  stylisPlugins: function stylisPlugins(context, content, selectors) {
    var selector = selectors[0];

    switch (context) {
      case 1:
        return content + " !important";

      case 3:
        if (selector === '@font-face' || selector.startsWith('@') && selector.includes('keyframes')) {
          return replaceAll(content, ' !important', '');
        }

        return content;

      default:
        return content;
    }
  },
  prefix: function prefix(key) {
    return !disablePrefix.includes(key);
  }
});

export default cache;
//# sourceMappingURL=cache.esm.js.map
